<div class="card">
  <div class="row g-0">
    <!-- Left Panel: Payment Form -->
    <div class="col-12 col-md-5 col-lg-4 bg-light p-4">
      <a class="text-decoration-none text-primary" href="javascript:void(0)" (click)="goBack()">
        Back
      </a>

      <div class="mt-4">
        <div class="row mb-3 align-items-center">
          <label class="col-4 col-form-label fw-bold">Payment Amount:</label>
          <div class="col-8">
            <select
              class="form-select"
              [(ngModel)]="selectedOptionId"
              (change)="onOptionChange()"
              [disabled]="isProcessing"
            >
              <option [ngValue]="null">-- Select an option --</option>
              <option *ngFor="let opt of paymentOptions" [ngValue]="opt.id">
                {{ opt.label }}
              </option>
            </select>
          </div>
        </div>

        <div class="row mb-3 align-items-center">
          <label class="col-4 col-form-label fw-bold">Amount:</label>
          <div class="col-8">
            <span class="fs-5">{{ amount | currency }}</span>
          </div>
        </div>
      </div>

      <div class="mt-auto pt-5">
        <button
          mat-raised-button
          class="w-100 pay-button"
          (click)="submitPayment()"
          [disabled]="!isFormValid() || isProcessing"
        >
          <span *ngIf="!isProcessing">Pay</span>
          <span *ngIf="isProcessing">
            <mat-spinner diameter="20" class="d-inline-block align-middle me-2"></mat-spinner>
            Processing...
          </span>
        </button>
      </div>
    </div>

    <!-- Right Panel: Instructions -->
    <div class="col-12 col-md-7 col-lg-8 p-4">
      <h4 class="text-decoration-underline mb-4">Make a Payment</h4>

      <p>
        Please select the number of certificates you need to purchase. Only purchase one certificate if you have not been instructed to do so by the Educator Certification Section or by the Alabama College/University where you completed your Educator Preparation Program.
      </p>

      <p>
        <span class="fw-bold">Note:</span> Please understand no refunds will be issued for online payments and a service fee will be applied to each payment. Payments made through this system will only be credited to the ACE account owner.
      </p>
    </div>
  </div>
</div>
